import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { SiteId } from 'app/site-detail/models/Site';

import { ButtonComponent } from '../../../shared/components/button/button.component';
import { useToaster } from '../../../shared/composables/use-toaster';
import { useVideoCall } from '../../composables/use-video-call';
import { getVideoCallToasterId } from '../../utils/getVideoCallToasterId';

@Component({
    selector: 'app-video-call-toast-action',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, ButtonComponent],
    template: `
        @if (videoCall.button.joinable()) {
            <button
                app-button
                variant="secondary"
                [loading]="videoCall.button.loading()"
                [disabled]="videoCall.button.disabled()"
                (click)="handleVideoCallAction()"
            >
                {{ videoCall.button.label() | translate }}
            </button>
        }
    `,
})
export class VideoCallToastActionComponent {
    private readonly toaster = useToaster();

    readonly siteId = input.required<SiteId>();

    // Joining needs no client: the toast only shows a call the client already joined.
    protected readonly videoCall = useVideoCall(this.siteId, signal(null), { analyticsSource: 'Toast' });

    protected async handleVideoCallAction(): Promise<void> {
        if (!this.videoCall.button.joinable()) {
            return;
        }

        const completed = await this.videoCall.button.handleAction();

        if (completed) {
            this.toaster.dismiss(getVideoCallToasterId(this.siteId()));
        }
    }
}
